module.exports = __webpack_public_path__ + "static/media/transfer.d3e337a7.svg";